<template>
    <td-dialog :title="$t('common.INSTALLPLUGIN')" :visible="dialogVisible" width="40%" :before-close="addDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" v-dialogDrag>
        <fieldset>
            <legend>{{ $t('common.UPLOADPLUGIN') }}</legend>
            <el-col :span="24">
                <td-upload
                    message="common.ONLYUPLOADZIPFILEONLYONE"
                    :action="importUrl"
                    ref="upload"
                    :on-remove="onRemove"
                    :file-list="fileList"
                    accept=".zip"
                    :with-credentials="withCredentials"
                    :autoUpload="true"
                    :limit="limit"
                    :on-exceed="handleExceed"
                    :on-change="handChange"
                    multiple
                    :http-request="myUpload"
                >
                </td-upload>
            </el-col>
        </fieldset>
        <fieldset>
            <legend>{{ $t('common.PLUGININFO') }}</legend>
            <el-row :gutter="20">
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('common.ID') }}</div></el-col
                >
                <el-col :span="9"><div ref="id" class="grid-content"></div></el-col>
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('pgCommon.NAME') }}</div></el-col
                >
                <el-col :span="9"><div ref="name" class="grid-content"></div></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('common.VERSION') }}</div></el-col
                >
                <el-col :span="9"><div ref="version" class="grid-content"></div></el-col>
                <el-col :span="3"
                    ><div class="grid-content">{{ $t('common.AUTHOR') }}</div></el-col
                >
                <el-col :span="9"><div ref="author" class="grid-content"></div></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content">{{ $t('common.DEPENDS') }}</div>
                </el-col>
                <el-col :span="21">
                    <div ref="depends" class="grid-content"></div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content">{{ $t('common.DESCRIPTION') }}</div>
                </el-col>
                <el-col :span="21">
                    <div ref="describe" class="grid-content"></div>
                </el-col>
            </el-row>
        </fieldset>
        <div slot="footer" class="dialog-footer">
            <td-button type="primary" :loading="addFormLoading" @click="submitForm('addForm')">{{ $t('common.INSTALL') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCEL') }}</td-button>
        </div>
    </td-dialog>
</template>
<style scoped>
.el-row {
    height: 40px;
}
.grid-content {
    height: 40px;
    line-height: 20px;
}
</style>
<script>
import pluginApi from './../assets/api.js';
export default {
    props: ['dialogVisible', 'baseUrl'],
    data() {
        return {
            uploadTip: '', // 上传插件按钮文字描述
            importUrl: '', // 上传文件默认调用方法
            fileList: [], // 上传文件集合
            withCredentials: true, // 支持发送 cookie 凭证信息
            describe: '',
            depends: '',
            fileUploadVo: {
                fileName: '', // 文件名称
                fullName: '', // 文件完整名称
                basePath: '', // 文件存储基础路径
                fileSize: null // 文件大小
            },
            uploadFileInfo: null, // 上传完成后zip包返回相关信息
            limit: 1, // 限制上传文件数量
            addFormLoading: false
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        // 页面初始化方法
        initData() {
            this.fileList = [];
            this.uploadTip = this.$t('common.UPLOADPLUGIN');
        },
        // dialog关闭前必调用的方法
        addDialogClose() {
            this.delteZipFile();
            this.$emit('addDialogClose');
        },
        // 点击取消
        cancel() {
            this.addDialogClose();
        },
        // 删除上传的zip包
        delteZipFile() {
            if (this.fileList.length > 0) {
                pluginApi.deleteZipFile({ fileName: this.fileList[0].name }, response => {
                    if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/plugin/deleteZipFile', response.data.statusMessage);
                        }
                    } else {
                        this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                        this.$log.error('/plugin/deleteZipFile', response);
                    }
                });
            }
        },
        // 本地选择文件时触发事件
        handChange(file, fileList) {
            this.fileList = fileList;
        },
        // 上传数量限制方法
        handleExceed(files, fileList) {
            this.$message.warning(this.$t('message.NOW_LIMIT_CHOOSE') + this.limit + this.$t('message.GE_FILE_'));
        },
        // 上传文件
        submitUpload() {
            this.$refs.upload.submit();
        },
        // 点击文件列表叉号触发事件
        onRemove(file, fileList) {
            this.delteZipFile();
            this.$refs.id.innerHTML = ''; // 插件ID
            this.$refs.name.innerHTML = ''; // 插件名称
            this.$refs.describe.innerHTML = ''; // 插件描述
            this.$refs.version.innerHTML = ''; // 插件版本
            this.$refs.author.innerHTML = ''; // 插件授权
            this.$refs.depends.innerHTML = ''; // 插件依赖
        },
        // 自定义上传文件方法
        myUpload(content) {
            let file = content.file;
            let fd = new FormData();
            fd.append('multipartFile', file);
            fd.append('fileName', this.fileUploadVo.fileName);
            let i = 0;
            pluginApi.uploadFile(fd, response => {
                if (i > 0) {
                    return;
                }
                i++;
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        content.onSuccess(response.data);
                        this.listZipPlugins(response.data.content.fileName);
                        this.$refs.upload.clearFiles();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/upload', response.data.statusMessage);
                        this.delteZipFile();
                        this.$refs.upload.clearFiles();
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/upload', response);
                    this.delteZipFile();
                    this.$refs.upload.clearFiles();
                }
            });
        },
        // 获取上传后插件zip包的基础信息
        listZipPlugins(fileName) {
            pluginApi.listZipPlugins({}, response => {
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== undefined && response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        for (let i = 0; i < response.data.content.length; i++) {
                            if (fileName === response.data.content[i].fileName) {
                                this.uploadFileInfo = response.data.content[i];
                                break;
                            }
                        }
                        this.setPluginInfo();
                    } else {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/plugin/listZipPlugins', response.data.statusMessage);
                    }
                } else {
                    this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    this.$log.error('/plugin/listZipPlugins', response);
                }
            });
        },
        // 给页面插件信息赋值
        setPluginInfo() {
            this.$refs.id.innerHTML = this.uploadFileInfo.pluginDescriptorVo.pluginId; // 插件id
            this.$refs.name.innerHTML = this.uploadFileInfo.pluginDescriptorVo.pluginName; // 插件名称
            this.$refs.version.innerHTML = this.uploadFileInfo.pluginDescriptorVo.version; // 插件版本
            this.$refs.author.innerHTML = this.uploadFileInfo.pluginDescriptorVo.provider; // 插件授权
            this.$refs.describe.innerHTML = this.uploadFileInfo.pluginDescriptorVo.pluginDescription; // 插件描述
            this.$refs.depends.innerHTML = this.uploadFileInfo.pluginDescriptorVo.dependenciesStr; // 插件依赖
        },
        // 点击确定
        submitForm() {
            this.addFormLoading = true;
            let fd = new FormData();
            if (null === this.uploadFileInfo) {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_ZIP'), type: 'warning' });
                this.addFormLoading = false;
                return;
            }
            var _this = this;
            fd.append('pluginId', this.uploadFileInfo.pluginId);
            pluginApi.install(fd, response => {
                if (response.status === window.pgCommon.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        setTimeout(() => {
                            _this.$emit('querypluginLIst');
                            _this.addDialogClose();
                            _this.addFormLoading = false;
                        }, 1000);
                    } else {
                        _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        _this.$log.error('/plugin/install', response.data.statusMessage);
                        _this.addFormLoading = false;
                    }
                } else {
                    _this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    _this.$log.error('/plugin/install', response);
                    _this.addFormLoading = false;
                }
            });
        }
    }
};
</script>
